const getPathForLocation = (location: Location) =>
  `${location.pathname}${location.search}${location.hash}`;

export default getPathForLocation;
